import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiStateService } from 'app/core/store/ui/state-service';
import { AuthStateService } from '../../../../../auth/store/auth.state-service';
import { User, UserListItem } from 'app/auth/model/User';
import { LIST_DATE_FORMAT, EditingStatus } from 'app/core/models/common-types';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'app/core/animations/route.animations';
import { ConfirmationService } from 'primeng/api';
import { Client, ClientListItem, clientDisplayedColumns } from 'app/features/admin/clients/model/Client';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import { ClientStateService } from '../../store/client.state-service';

@Component({
  selector: 'app-client-list',
  standalone: true,
  imports: [CommonModule, PrimeNgModule],
  templateUrl: './client-list.component.html',
  // styleUrls: ['./client-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientListComponent implements OnInit, OnDestroy {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  clientDisplayedColumns = clientDisplayedColumns;
  dataSource: Client[];
  dateFormat = LIST_DATE_FORMAT;
  // isMobileDevice$: Observable<boolean> = this.uiStateService.isMobileDevice$
  isLoading$ = this.uiStateService.isLoading$;
  user: User;
  userListItems: UserListItem[];
  // isClientSelected$: Observable<boolean> = this.rcAdminStateService.isClientSelected$;
  isSuperUser = false;
  selectedClient: Client;
  tableHeight = '40rem';
  clients: Client[];
  importLeadList: Client[];
  importListBadEmails: Client[];

  private subscriptions = new Subscription();
  constructor(
    private changeDetector: ChangeDetectorRef,
    private clientStateService: ClientStateService,
    private uiStateService: UiStateService,
    private authStateService: AuthStateService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    console.log('MS ClientListComponent');
    this.subscriptions.add(
      this.authStateService.loggedInUser$.subscribe((user) => {
        this.user = user;
      })
    );
    this.subscriptions.add(
      this.authStateService.isSuperUser$.subscribe((isSuperUser) => {
        this.isSuperUser = isSuperUser;
        // if (isSuperUser) {
        //   this.addDataCleanUpSubscriptions();
        // }
      })
    );
    this.subscriptions.add(
      this.authStateService.userListItems$.subscribe((userListItems) => {
        this.userListItems = userListItems;
      })
    );

    this.subscriptions.add(
      this.clientStateService.clientListItems$.subscribe((clients) => {
        this.clients = clients;
        console.log('MS onProductActionSelected this.clients= ', this.clients);
        this.dataSource = [...clients];
        this.changeDetector.detectChanges();
        this.setTableHeight();
      })
    );
  }

  onRowSelect(row) {
    console.log('MS onRowSelect row.data= ', row.data);
    console.log('MS onRowSelect this.selectedClient= ', this.selectedClient);
    this.onEditClient(row.data);
  }

  onAddClient() {
    // this.selectedRowIndex = undefined;
    this.clientStateService.setClientEditingStatus(EditingStatus.ADDING);
    this.router.navigate(['/admin/edit-client', EditingStatus.ADDING]);
  }

  onEditClient(clientListItem: ClientListItem) {
    // this.selectedRowIndex = client.id;
    console.log('MS onEditClient clientListItem= ', clientListItem);
    console.log('MS onEditClient this.selectedClient= ', this.selectedClient);
    this.clientStateService.setClientEditingStatus(EditingStatus.EDITING);
    this.clientStateService.setSelectedClient(clientListItem);
    this.router.navigate(['/admin/edit-client', EditingStatus.EDITING]);
  }

  onDeleteClient(client: Client) {
    if (!this.isSuperUser) {
      this.confirmationService.confirm({
        header: 'Remove Client',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        message: 'You are removing a Client from the database!<p><p>Do you want to continue?',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          this.clientStateService.deleteClient(client.id);
        },
        // reject: () => {
        //     this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      });
    } else {
      this.clientStateService.deleteClient(client.id);
    }
  }
  // const modalRef = this.confirmationService.open({
  //   title: 'Import Clients',
  //   actions: ['Yes', 'No'],
  //   description: `There were ${addedCtr} and ${duplicateCtr} duplicates found. Import them?`,
  // });
  // modalRef.confirm$.subscribe(() => {
  //   this.confirmationService.dismiss();
  //   // if (newClientList.length > 0) {
  //   //   this.clientStateService.addMultipleClients(this.importLeadList);
  //   // }
  // });
  // this.confirmationService.open({
  //   title: 'Import Clients',
  //   description: `There were ${addedCtr} and ${duplicateCtr} duplicates found.`,
  //   actions: ['OK'],
  // });
  // } else {
  //   this.confirmationService.open({
  //     title: 'Import Clients Error',
  //     description: 'No Clients Imported! Did you select the correct Format and/or File?',
  //     actions: ['OK'],
  //   });
  // }
  // }

  onDone() {
    this.router.navigate(['/admin']);
  }

  setTableHeight() {
    this.tableHeight = `${window.innerHeight - 120}px`;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setTableHeight();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
